import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { PricingModeViewTabs } from "./pricing-mode-view-tabs";

import { TableOnewayPricing } from "./table-oneway-pricing";
import { TableHourlyPricing } from "./table-hourly-pricing";
import { TableLongDistancePricing } from "./table-long-distance-pricing";

import { MODES } from "../../constants/booking-modes";

export function PricingView() {
  const dispatch = useDispatch();

  const authToken = useSelector(({ auth }) => auth.token);

  const currentSelectedCityId = useSelector(
    ({ pricing }) => pricing.currentSelectedCityId
  );

  const { isZoneFetched, zoneRefetchCount } = useSelector(
    ({ pricing }) => pricing.cities[currentSelectedCityId]
  );

  const currentPricingView = useSelector(
    ({ pricing }) => pricing.currentPricingView
  );

  React.useEffect(() => {
    if (!isZoneFetched)
      dispatch({
        type: "EXTRANET_GET_ALL_ZONES_BY_CITY_ID",
        payload: {
          token: authToken,
          cityId: currentSelectedCityId,
        },
      });
  }, [isZoneFetched, zoneRefetchCount, currentSelectedCityId, authToken]);

  return (
    <>
      <div className="sticky z-10 top-0 bg-black h-14 pb-4 flex justify-between items-center w-full">
        <PricingModeViewTabs />
      </div>

      <div className="relative overflow-y-scroll pb-4 scrollbar-none">
        {currentPricingView === MODES[0] && <TableOnewayPricing />}
        {currentPricingView === MODES[1] && <TableHourlyPricing />}
        {currentPricingView === MODES[2] && <TableLongDistancePricing />}
      </div>
    </>
  );
}
